import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './profile.css'
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getUserInfo, UpdateUserInfo, changePass, getAddress, addAddress, getCity, getProvince } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import { Accordion } from 'react-bootstrap'
import useToastNotification from '../../hooks/useToastNotification';

import { Dropdown } from 'primereact/dropdown';


//icon
import MapIcon from '../../assets/icons/address/map.svg'

function Profile() { // Receive onProfileLoad as a prop
  const toast = useRef(null);
  const [createDate, setCreateDate] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordLoader, setPasswordLoader] = useState(false);
  const [passValidated, setPassValidated] = useState(false);
  const [validated, setValidated] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [address, setAddress] = useState('');
  const [fullName, setFullName] = useState('');
  const [mobile, setMobile] = useState('');
  const [userName, setUserName] = useState('');
  const [addressId, setAddressId] = useState('');
  const { showError, showSuccess } = useToastNotification();
  const [oldPass, setOldPass] = useState('');
  const [phone, setPhone] = useState('');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [newPass, setNewPass] = useState('');
  const [nikName, setNikname] = useState('');
  const [confirmPass, setConfirmPass] = useState('');

  const [mahiyat, setMahiyat] = useState({
    code: 3,
    name: 'نامشخص'
  });
  const [email, setEmail] = useState('');
  const [customerData, setCustomerData] = useState();
  const getCustomer = async (id) => {
    try {
      setLoading(true)
      let response = await getUserInfo(id);
      if (response.data != null) {

        setEmail(response.data.email)
        setMobile(response.data.phone)
        setFullName(response.data.fullname)
        setAddress(response.data.adres)
        setUserName(response.data.loginname)
        setMahiyat({
          code: response.data.mahiyat,
          name: response.data.mahiyat === 'B' ? 'حقیقی' : 'حقوقی'
        })

        setCreateDate(response.data.datestart)
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)

    }
  }

  const fetchProvince = async () => {
    try {
      // setLoading(true)
      let res = await getProvince()
      console.log(res)
      if (res.status == '200') {
        setLoading(false)
        setProvinces(res.data)
        console.log(res.data)
      }

    } catch (error) {

    } finally {
      setLoading(false)
    }
  }
  const fetchCity = async (id) => {
    try {
      let res = await getCity(id)
      console.log(res)
      if (res.status == '200') {
        setCities(res.data)
      }

    } catch (error) {

    } finally {
    }
  }
  const fetchAddress = async () => {
    try {
      // setLoading(true)
      let res = await getAddress(JSON.parse(localStorage.getItem('userInfo')).si)
      if (res.status == '200') {
        setLoading(false)
        const addresses = res.data;
        setAddressList(addresses);
        setTimeout(() => {
          if (addresses.length > 0) {
            setAddressId(addresses[0].Si); // انتخاب اولین آدرس
          }
        }, 1000);

      }

    } catch (error) {

    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    let customerDatares = window.localStorage.getItem('userInfo');
    setCustomerData(JSON.parse(customerDatares));
    getCustomer(JSON.parse(customerDatares).si);
    setTimeout(() => {
      fetchAddress()
    }, 500);
    setTimeout(() => {
      fetchProvince()
    }, 800);
  }, []);


  const convertDateToPersian = (date) => {
    if (!date) return '-';
    return moment(date).locale("fa").format("YYYY/MM/DD");
  };
  // const convertDateToEn = (date) => {
  //     if (!date) return '-';
  //     console.log(moment(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD'))
  //     return moment(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD');
  // };


  const changePassword = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      if (newPass != confirmPass) {
        showError('لطفا رمز عبور خود را یکسان وارد کنید.')
        return
      }
      event.stopPropagation();
      try {
        setPasswordLoader(true);
        let pay = {
          UserId: (customerData.si).toString(),
          Pass: oldPass,
          NewPass: newPass,
          Login: userName,
        }
        let response = await changePass(pay);

        if (response.data.res === 'Ok') {

          setPasswordLoader(false);
          setNewPass('')
          setOldPass('')
          setConfirmPass('')
          setPassValidated(false)
          showSuccess('رمز عبور با موفقیت تغییر کرد.');

        } else if (response.data.res === 'NotOk') {
          setPasswordLoader(false);

          let error = {
            title: 'اخطار',
            text: response.data.restp,
          };
          showError(error);
        }
      } catch (error) {
        setPasswordLoader(false);
        console.log(error);
        showError('خطا در برقراری ارتباط...');
      }
    }

    setPassValidated(true);
  }
  const mahiyatOption = [
    { name: 'حقیقی', code: 'B' },
    { name: 'حقوقی', code: 'C' }];
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]

  const updateInfo = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      event.stopPropagation();
      try {
        setAddressLoader(true);
        let pay = {
          id: (customerData.si).toString(),
          phone: phone,
          mobile: mobile,
          fullName: fullName,
          address: address,
          mahiyat: mahiyat.code,
          email: email
        }
        let response = await UpdateUserInfo(pay);

        if (response.data.res === 'Ok') {

          setAddAddressVisible('')
          setAddressLoader(false)
          showSuccess('اطلاعات ویرایش شد.');

        } else if (response.data.res === 'NotOk') {
          setAddressLoader(false);

          let error = {
            title: 'اخطار',
            text: response.data.restp,
          };
          showError(error);
        }
      } catch (error) {
        setAddressLoader(false);
        console.log(error);
        showError('خطا در برقراری ارتباط...');
      }
    }

    setValidated(true);
  }

  //address
  const [visibleAddress, setVisibleAddress] = useState(false)
  const [addressLoader, setAddressLoader] = useState(false)
  const [addAddressVisible, setAddAddressVisible] = useState(false)
  const [addAddressValidate, setAddAddressValidate] = useState(false)
  const [city, setCity] = useState('')
  const [addressMobile, setAddressMobile] = useState('')
  const [province, setProvince] = useState('')
  const [addressFeild, setAddressFeild] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const handleDialogClose = () => {
    setVisibleAddress(false);
  };
  const handleAddDialogClose = () => {
    setAddAddressVisible(false);
  };
  const getCityById = (id) => {
    setProvince(id)
    fetchCity(id.Si)
  };
  const handleAddressSelect = (selectedAddress, lat, lng) => {
    setLng(lng)
    setLat(lat)
    setAddressFeild(selectedAddress);
  };
  const addAddressFunc = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!city.Si || !province.Si) {
      showError('لطفا استان و شهر را وارد کنید')
      return
    }
    if (form.checkValidity() === true) {
      event.stopPropagation();
      try {
        setAddressLoader(true);
        let pay = {
          userId: (customerData.si).toString(),
          phone: addressMobile,
          postal: postalCode,
          address: addressFeild,
          cityId: (city.Si).toString(),
          ostanId: (province.Si).toString(),
          adresId: '0',
          active: 'A',
          lat: lat ? parseInt(lat).toString() : '',
          leng: lng ? parseInt(lng).toString() : '',
          nikeName: nikName,
        }
        let response = await addAddress(pay);

        if (response.status == '200') {

          setAddAddressVisible('')
          setAddressLoader(false)
          fetchAddress()
          showSuccess('آدرس با موفقیت افزوده شد.');

        } else if (response.data.res === 'NotOk') {
          setAddressLoader(false);

          let error = {
            title: 'اخطار',
            text: response.data.restp,
          };
          showError(error);
        }
      } catch (error) {
        setAddressLoader(false);
        console.log(error);
        showError('خطا در برقراری ارتباط...');
      }
    }

    setAddAddressValidate(true);
  }



  return (
    <>
      {loading && <LoaderPage isLoading={loading} />}

      <div className='profile-card'>
        <h6 className='page-title my-4'>حساب کاربری</h6>
        <Form className='row gx-5 mb-4 gy-2' noValidate validated={validated} onSubmit={(e) => updateInfo(e)}>
          <Form.Group className="col-md-6 col-lg-3 col-sm-12">
            <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
            <Form.Control type="text" required value={fullName} onChange={(e) => setFullName(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              نام و نام خانوادگی را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="col-md-6 col-lg-3 col-sm-12">
            <Form.Label>ماهیت <span className='text-[red]'> * </span></Form.Label>
            <Dropdown value={mahiyat} onChange={(e) => { setMahiyat(e.value); console.log(e.value) }} options={mahiyatOption} optionLabel="name"
              className="w-100 " />

          </Form.Group>
          <Form.Group className="col-md-6 col-lg-3 col-sm-12">
            <Form.Label>ایمیل <span className='text-[red]'> * </span></Form.Label>
            <Form.Control type="text" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              ایمیل را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col-md-6 col-lg-3 col-sm-12">
            <Form.Label>شماره همراه <span className='text-[red]'> * </span></Form.Label>
            <Form.Control type="number" required disabled value={mobile} onChange={(e) => setMobile(e.target.value)} />
          </Form.Group>
          {
            mahiyat.code === 'C' && (
              <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                <Form.Label>تلفن <span className='text-[red]'> * </span></Form.Label>
                <Form.Control type="number" required disabled value={phone} onChange={(e) => setPhone(e.target.value)} />
              </Form.Group>

            )
          }
          <Form.Group className="col-md-6 col-lg-3 col-sm-12">
            <Form.Label>تاریخ ثبت <span className='text-[red]'> * </span></Form.Label>
            <DatePicker
              disabled
              weekDays={weekDays}
              value={createDate}
              onChange={(date) => setCreateDate(convertDateToPersian(date.toDate()))}
              calendar={persian}
              locale={persian_fa}
            />
          </Form.Group>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>آدرس</Form.Label>

            <div className='d-flex align-items-center gap-2'>
              <Dropdown value={addressId} onChange={(e) => setAddressId(e.value)} options={addressList} optionLabel="Addres"
                emptyMessage="هیچ آدرسی یافت نشد" className="w-100 " optionValue="Si" />
              {/* <Form.Control type="text" value={address} onChange={(e) => setAddress(e.target.value)} /> */}
              <button type='button' className='btn w-[40px] btn-address' style={{ backgroundColor: '#00a14b', height: '40px', fontSize: '20px', color: '#fff' }} onClick={() => setAddAddressVisible(true)}>
                +
              </button>
            </div>
          </Form.Group>


          <div className='text-start d-flex justify-content-end w-100 mt-3'>
            <button type='submit' disabled={loader} className='btn btn-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }} >
              {loader && <Loadr />}ذخیره اطلاعات
            </button>
          </div>
        </Form>


        <Accordion >
          <div className='flex flex-wrap [&>div]:!px-0 [&_.accordion-outer]:p-1 w-100'>
            <div className='accordion-outer w-100'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>تغییر رمز عبور</Accordion.Header>
                <Accordion.Body>
                  <Form className='mb-4' noValidate validated={passValidated} onSubmit={(e) => changePassword(e)}>
                    <div className='row gx-5 gy-2'>
                      <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                        <Form.Label>رمز قدیم</Form.Label>
                        <Form.Control type="password" required value={oldPass} onChange={(e) => setOldPass(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                          رمز قدیم را وارد کنید
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className='row gx-5 gy-2 mt-2'>
                      <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                        <Form.Label>رمز جدید</Form.Label>
                        <Form.Control type="password" required value={newPass} onChange={(e) => setNewPass(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                          رمز جدید را وارد کنید
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                        <Form.Label>تکرار رمز جدید</Form.Label>
                        <Form.Control type="password" required value={confirmPass} onChange={(e) => setConfirmPass(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                          تکرار رمز جدید را وارد کنید
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>




                    <div className='row mt-3'>
                      <div className='col-sm-12 col-md-6 col-lg-8'>

                      </div>
                      <div className='col-sm-12 col-md-6 col-lg-4 gap-2 d-flex'>
                        <button type='button' disabled={loader} className='w-50 btn btn-outline-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }} onClick={() => {
                          setNewPass('')
                          setOldPass('')
                          setConfirmPass('')
                          setPassValidated(false)
                        }}>
                          انصراف
                        </button>
                        <button type='submit' disabled={loader} className='btn w-50 btn-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }} >
                          {passwordLoader && <Loadr />}ذخیره اطلاعات
                        </button>

                      </div>
                    </div>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            </div>
          </div>
        </Accordion>

      </div>



      <Dialog draggable={false} header="موقعیت مکانی" className="custom-dialog dialog-profile" visible={visible} maximizable onHide={() => setVisible(false)}>
        <h6 className='my-2 mb-4'>لطفا موقعیت مکانی خود را مشخص کنید.</h6>
        <MapComponent
          lat={lat}
          lng={lng}
          onSelect={handleAddressSelect}
        />
        <button type='button' className='btn w-100 btn-primary mt-4 ' onClick={() => setVisible(false)}>
          ثبت
        </button>
      </Dialog>

      {/* address  */}
      <Dialog
        draggable={false}
        dismissableMask
        visible={visibleAddress}
        style={{ width: '40vw' }}
        breakpoints={{ '600px': '400vw', '500px': '100vw' }}
        onHide={handleDialogClose}
        className="custom-dialog dialog-profile"
      >

        <div className='w-100 text-left d-flex justify-content-end'>
          <button className='btn btn-primary' onClick={() => setAddAddressVisible(true)}>افزودن آدرس جدید</button>

        </div>
      </Dialog>

      <Dialog
        draggable={false}
        dismissableMask
        visible={addAddressVisible}
        style={{ width: '40vw' }}
        breakpoints={{ '600px': '400vw', '500px': '100vw' }}
        onHide={handleAddDialogClose}
        className="custom-dialog dialog-profile"
      >

        <Form className='row  mb-4 gy-3 px-2' noValidate validated={addAddressValidate} onSubmit={(e) => addAddressFunc(e)}>
          <button type='button' className='btn btn-outline-primary d-flex align-items-center justify-content-center gap-2 w-100' onClick={() => setVisible(true)}> <img src={MapIcon} />انتخاب موقعیت مکانی</button>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
            <Form.Control required type="text" value={nikName} onChange={(e) => setNikname(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              نام و نام خانوادگی را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>موبایل <span className='text-[red]'> * </span></Form.Label>
            <Form.Control required type="number" value={addressMobile} onChange={(e) => setAddressMobile(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              موبایل را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
            <Dropdown value={province} onChange={(e) => getCityById(e.value)} options={provinces} optionLabel="CName"
              className="w-100 " />
          </Form.Group>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
            <Dropdown value={city} onChange={(e) => setCity(e.value)} options={cities} optionLabel="CName"
              className="w-100 " />          </Form.Group>
          <Form.Group className="col-md-6 col-lg-6 col-sm-12">
            <Form.Label>کدپستی <span className='text-[red]'> * </span></Form.Label>
            <Form.Control required type="number" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              کدپستی را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col-md-12 col-lg-12 col-sm-12">
            <Form.Label>آدرس <span className='text-[red]'> * </span></Form.Label>
            <Form.Control required type="text" as="textarea" rows={3} value={addressFeild} onChange={(e) => setAddressFeild(e.target.value)} />
            <Form.Control.Feedback type="invalid">
              آدرس را وارد کنید.
            </Form.Control.Feedback>
          </Form.Group>



          <div className='text-start d-flex justify-content-end w-100'>
            <button type='submit' disabled={loader} className='btn btn-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }}>
              {addressLoader && <Loadr />}ثبت آدرس
            </button>
          </div>
        </Form>
      </Dialog>
    </>
  );
}

export default Profile;
